<div class="sp-order-details-installments__grid sp-min-height__full">
  <app-order-details-installments-info
    *ngIf="!is_list_steps_running"
    [steps]="steps"></app-order-details-installments-info>

  <app-order-details-installments-unpaids
    *ngIf="!is_list_unpaids_running"
    [unpaids]="unpaids"></app-order-details-installments-unpaids>

  <app-loading *ngIf="is_list_steps_running"></app-loading>

  <app-loading *ngIf="is_list_unpaids_running"></app-loading>
</div>
